import { useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import makeStyles from "@mui/styles/makeStyles";
import { CognitoAuthContext } from "components/Authentication/CognitoAuthContext";

const useStyles = makeStyles({
  wrapper: {
    position: "absolute",
    width: "100%",
    height: "100%",
    margin: 0
  }
});

// this component is best to be used on the highest level possible in the dom tree.
// it is meant for whole page loading progress indication.
function Preloader({ text, failure, failureText, showLogout }) {
  const { logout } = useContext(CognitoAuthContext);

  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div
        className={cx({
          preloader: true,
          "preloader--done": failure
        })}
      >
        <div className="preloader__enter">
          <div className="preloader__bounce">
            <div className="preloader__logo" />
          </div>
        </div>
        <div className="preloader__text">{text}</div>
        <div className="preloader__text preloader__text--fail">
          <p>
            <strong>{failureText}</strong>
            {failureText && failureText.indexOf("not authorized") > -1 ? (
              <>
                <br />
                <span style={{ fontSize: "1rem" }}>
                  Your user account hasn&apos;t been configured to be used with
                  AIHUB yet. Please contact the administrator to setup your
                  account if you need access to AIHUB.
                </span>
              </>
            ) : null}
            <br />
            <br />
          </p>
          {showLogout && (
            <p>
              <small style={{ textAlign: "center" }}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" onClick={() => logout()}>
                  Back to login
                </a>
              </small>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

Preloader.propTypes = {
  text: PropTypes.string,
  failure: PropTypes.bool,
  failureText: PropTypes.string,
  showLogout: PropTypes.bool
};

Preloader.defaultProps = {
  text: "Loading...",
  failure: false,
  failureText:
    "If you're seeing this AIHUB has failed to load its application files"
};

export default Preloader;
